import { State, Action, StateContext, Selector } from '@ngxs/store';
import {
  RecentSalesFilters,
  InProgApplicationFilter,
  PayoutFilter,
  StaffFilter
} from '../models/filter.models';
import {
  RecentSaleFilterConfig,
  InProgApplicationFilterConfig,
  PayoutFilterConfig,
  StaffSearchConfig,
  ResetFilters
} from '../actions/filter.actions';
import { Injectable } from '@angular/core';

export class FilterStateModel {
  recentSaleFilters?: RecentSalesFilters;
  inProgApplicationFilters?: InProgApplicationFilter;
  payoutFilters?: PayoutFilter;
  staffFilters?: StaffFilter;
}
@State<FilterStateModel>({
  name: 'filter'
})
@Injectable()
export class FilterState {
  @Selector()
  static recentSaleFilters(state: FilterStateModel) {
    return state.recentSaleFilters;
  }

  @Selector()
  static inProgApplicationFilters(state: FilterStateModel) {
    return state.inProgApplicationFilters;
  }

  @Selector()
  static payoutFilters(state: FilterStateModel) {
    return state.payoutFilters;
  }

  @Selector()
  static staffFilters(state: FilterStateModel) {
    return state.staffFilters;
  }
  constructor() {}

  @Action(RecentSaleFilterConfig)
  recentSaleFilterConfig(
    { getState, patchState }: StateContext<FilterStateModel>,
    { search, status, date }
  ) {
    const state = getState() || {};
    patchState({
      ...state,
      recentSaleFilters: {
        ...{ search, status, date }
      }
    });
  }

  @Action(InProgApplicationFilterConfig)
  inProgApplicationFilterConfig(
    { getState, patchState }: StateContext<FilterStateModel>,
    { search, status, date }
  ) {
    const state = getState() || {};
    patchState({
      ...state,
      inProgApplicationFilters: {
        ...{ search, status, date }
      }
    });
  }

  @Action(PayoutFilterConfig)
  payoutFilterConfig(
    { getState, patchState }: StateContext<FilterStateModel>,
    { store, date }
  ) {
    const state = getState() || {};
    patchState({
      ...state,
      payoutFilters: {
        ...{ store, date }
      }
    });
  }

  @Action(StaffSearchConfig)
  staffSearchConfig(
    { getState, patchState }: StateContext<FilterStateModel>,
    { search, store }
  ) {
    const state = getState() || {};
    patchState({
      ...state,
      staffFilters: {
        ...{ search, store }
      }
    });
  }

  @Action(ResetFilters)
  reset({ setState }: StateContext<FilterStateModel>) {
    setState(undefined);
  }
}
